import type React from 'react';
import {MdError} from 'react-icons/md';

type ReminderTextProps = {
  texts: string[];
};

/**
 * リマインダーテキスト表示コンポーネント
 * 複数のリマインダーテキストを表示する汎用コンポーネント
 */
export const ReminderText: React.FC<ReminderTextProps> = ({texts}) => {
  // テキストが存在しない場合は何も表示しない
  if (texts.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4">
      {texts.map((text, index) => (
        <div
          key={index}
          className="flex text-sm text-notification font-medium items-center gap-4"
        >
          <MdError />
          {text}
        </div>
      ))}
    </div>
  );
};
